module.exports = "/assets/dist/images/carsaver_logoLightBlue.svg?b86474dd59b0c0b0b3b078c518962c7e";